import { USER_POST_RECEIVED } from './postUserAction';

const initialState = new Map();


export default (previousState = initialState, { type, user, postId }) => {
    if (type === USER_POST_RECEIVED) {
        previousState[postId] = user;
        return previousState;
    }
    return previousState;
}